module.exports = __webpack_public_path__ + "icon-2.svg?53329d912fdd0c995ceabfa420f51192";